import { useMemo } from 'react';

import { useEventsQuery } from '../generated/graphql';

const useWeddingDayId = (): string => {
  const { data: eventsData } = useEventsQuery();
  // For old temp messaging hub we also need to account for Ceremony event
  return (
    useMemo(() => eventsData?.events.find(e => ['WeddingDay', 'Ceremony'].includes(e.type || ''))?.id, [eventsData]) ||
    ''
  );
};

export default useWeddingDayId;
